<template>
  <div class="job-list-item__date">
    <slot
      :date="date"
      :dateStart="dateStart"
      :dateEnd="dateEnd"
      :dateSpanDaysCount="dateSpanDaysCount"
      :dateSpanOut="dateSpanOut"
    >
      <button
        :class="`job-date job-date--${date.type}`"
        @click="$emit('date-clicked', date)"
      >
        <slot :name="`date-icon-${date.type}`">
          <img :src="getIconSrc(date.type)" />
        </slot>

        <template v-if="dateSpanDaysCount > 0">
          <div class="job-date__multi-days">
            <span class="job-date__multi-days__start"
              >{{ dateOut(dateStart) }} -</span
            >
            <span class="job-date__multi-days__end">{{
              dateOut(dateEnd)
            }}</span>
          </div>
        </template>
        <span v-else>{{ dateSpanOut(dateStart, dateEnd) }}</span>
      </button>
      <span
        v-if="date.duration && showDuration"
        class="job-date job-date--duration"
      >
        <slot name="date-icon-duration"
          ><img :src="getIconSrc('duration')" /></slot
        ><span>{{
          date.duration +
          " " +
          __(
            `main.common.time_units.short.${date.duration_unit}`,
            Number(date.duration)
          )
        }}</span>
      </span>
    </slot>
  </div>
</template>

<script>
import { format } from "date-fns";
import { toDate } from "../../helpers/common";
import NeedsIcons from "../Mixins/NeedsIcons";
import { start } from "@popperjs/core/lib/enums";
import moment from "moment";

export default {
  mixins: [NeedsIcons],
  props: {
    date: {
      type: Object,
      required: true,
    },
    showDuration: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dateStart() {
      return toDate(this.date.start);
    },
    dateEnd() {
      return toDate(this.date.end);
    },
    /**
     * @see https://stackoverflow.com/questions/2627473/how-to-calculate-the-number-of-days-between-two-dates
     */
    dateSpanDaysCount() {
      // The number of milliseconds in all UTC days (no DST)
      const oneDay = 1000 * 60 * 60 * 24;

      // A day in UTC always lasts 24 hours (unlike in other time formats)
      const start = Date.UTC(
        this.dateEnd.getFullYear(),
        this.dateEnd.getMonth(),
        this.dateEnd.getDate()
      );
      const end = Date.UTC(
        this.dateStart.getFullYear(),
        this.dateStart.getMonth(),
        this.dateStart.getDate()
      );
      // so it's safe to divide by 24 hours
      return (start - end) / oneDay;
    },
  },
  methods: {
    dateOut(date, timeOnly = false) {
      return timeOnly
        ? moment(toDate(date), "YYYY.MM.DD HH:mm").format("HH:mm")
        : moment(toDate(date), "YYYY.MM.DD HH:mm").format("DD.MM.Y HH:mm");
    },
    dateSpanOut(startDate, endDate, full = false) {
      let mm = full
        ? this.dateOut(startDate) + " - " + this.dateOut(endDate, false)
        : this.dateOut(startDate) + " - " + this.dateOut(endDate, true);
      return mm;
    },
  },
};
</script>